// extracted by mini-css-extract-plugin
module.exports = {"logo":"Cabinet_logo__3GFrU","logo_container":"Cabinet_logo_container__1uOi5"};